// @ts-expect-error moduleResolution:nodenext issue 54523
import { html, LitElement, nothing } from 'lit';
// @ts-expect-error moduleResolution:nodenext issue 54523
import { customElement, property } from 'lit/decorators.js';
import LightElement from './light-element.js';
// @ts-expect-error moduleResolution:nodenext issue 54523
import { unsafeHTML } from 'lit/directives/unsafe-html.js';

@customElement('merch-overlay')
export default class MerchOverlay extends LightElement {

	@property({ type: String })
	shortText: string;

	@property({ type: String })
	longText?: string;

	@property({ type: String })
	backgroundColor: string;

	@property({ type: String })
	textColor: string;

	@property({ type: Boolean })
	inline: boolean;

	@property({ type: String })
	testName = "product-overlay";

	connectedCallback() {
		super.connectedCallback();
		
		// Remove placeholder elements on load
		const placeholders = this.querySelectorAll('.c-merch-overlay__placeholder');
		placeholders.forEach(placeholder => placeholder.remove());
	}

	render() {

		return html` 
			<p class="c-merch-overlay ${this.inline ? 'c-merch-overlay--inline' : ''}" style="background-color: ${this.backgroundColor}; color:${this.textColor};" data-test="${this.testName}">
				${unsafeHTML(this.longText ? this.longText : this.shortText)}
			</p>
		`;

	}

}
